const cultures ={
    "id": 44888847,
    "result": [{
            "Alias": "eu",
            "Culture": "en-US",
            "EnglishTitle": "English (European)",
            "NativeTitle": "English (European)",
            "IsoRegionName2": "us",
            "IsoRegionName3": "eng",
            "IsoCurrencySymbol": "USD",
            "NativeCurrencySymbol": "$",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/eu.svg"
        }, {
            "Alias": "sl-SI",
            "Culture": "sl-SI",
            "EnglishTitle": "Slovenian (Slovenia)",
            "NativeTitle": "Slovenščina (Slovenija)",
            "IsoRegionName2": "si",
            "IsoRegionName3": "slv",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/si.svg"
        }, {
            "Alias": "sr-Latn-RS",
            "Culture": "sr-Latn-RS",
            "EnglishTitle": "Serbian (Latin, Serbia)",
            "NativeTitle": "Srpski (Srbija)",
            "IsoRegionName2": "rs",
            "IsoRegionName3": "srp",
            "IsoCurrencySymbol": "RSD",
            "NativeCurrencySymbol": "RSD",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/rs.svg"
        }, {
            "Alias": "sr-Latn-ME",
            "Culture": "sr-Latn-ME",
            "EnglishTitle": "Montenegrin (Montenegro)",
            "NativeTitle": "Crnogorski (Crna Gora)",
            "IsoRegionName2": "me",
            "IsoRegionName3": "srp",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/me.svg"
        }, {
            "Alias": "hr-HR",
            "Culture": "hr-HR",
            "EnglishTitle": "Croatian (Croatia)",
            "NativeTitle": "Hrvatski (Hrvatska)",
            "IsoRegionName2": "hr",
            "IsoRegionName3": "hrv",
            "IsoCurrencySymbol": "HRK",
            "NativeCurrencySymbol": "kn",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/hr.svg"
        }, {
            "Alias": "mk-MK",
            "Culture": "mk-MK",
            "EnglishTitle": "Macedonian (North Macedonia)",
            "NativeTitle": "Makedonski (Severna Makedonija)",
            "IsoRegionName2": "mk",
            "IsoRegionName3": "mkd",
            "IsoCurrencySymbol": "MKD",
            "NativeCurrencySymbol": "ден",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/mk.svg"
        }, {
            "Alias": "it-IT",
            "Culture": "it-IT",
            "EnglishTitle": "Italian (Italy)",
            "NativeTitle": "Italiano (Italia)",
            "IsoRegionName2": "it",
            "IsoRegionName3": "ita",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/it.svg"
        }, {
            "Alias": "pl-PL",
            "Culture": "pl-PL",
            "EnglishTitle": "Polish (Poland)",
            "NativeTitle": "Polski (Polska)",
            "IsoRegionName2": "pl",
            "IsoRegionName3": "pol",
            "IsoCurrencySymbol": "PLN",
            "NativeCurrencySymbol": "zł",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/pl.svg"
        }, {
            "Alias": "ro-RO",
            "Culture": "ro-RO",
            "EnglishTitle": "Romanian (Romania)",
            "NativeTitle": "Română (România)",
            "IsoRegionName2": "ro",
            "IsoRegionName3": "ron",
            "IsoCurrencySymbol": "RON",
            "NativeCurrencySymbol": "RON",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/ro.svg"
        }, {
            "Alias": "fr-FR",
            "Culture": "fr-FR",
            "EnglishTitle": "French (France)",
            "NativeTitle": "Français (France)",
            "IsoRegionName2": "fr",
            "IsoRegionName3": "fra",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/fr.svg"
        }, {
            "Alias": "de-DE",
            "Culture": "de-DE",
            "EnglishTitle": "German (Germany)",
            "NativeTitle": "Deutsch (Deutschland)",
            "IsoRegionName2": "de",
            "IsoRegionName3": "deu",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/de.svg"
        }, {
            "Alias": "nl-NL",
            "Culture": "nl-NL",
            "EnglishTitle": "Dutch (Netherlands)",
            "NativeTitle": "Nederlands (Nederland)",
            "IsoRegionName2": "nl",
            "IsoRegionName3": "nld",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/nl.svg"
        }, {
            "Alias": "es-ES",
            "Culture": "es-ES",
            "EnglishTitle": "Spanish (Spain)",
            "NativeTitle": "Español (España)",
            "IsoRegionName2": "es",
            "IsoRegionName3": "spa",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/es.svg"
        }, {
            "Alias": "et-EE",
            "Culture": "et-EE",
            "EnglishTitle": "Estonian (Estonia)",
            "NativeTitle": "Eesti (Eesti)",
            "IsoRegionName2": "ee",
            "IsoRegionName3": "est",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/ee.svg"
        }, {
            "Alias": "sk-SK",
            "Culture": "sk-SK",
            "EnglishTitle": "Slovak (Slovakia)",
            "NativeTitle": "Slovenčina (Slovensko)",
            "IsoRegionName2": "sk",
            "IsoRegionName3": "slk",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/sk.svg"
        }, {
            "Alias": "cs-CZ",
            "Culture": "cs-CZ",
            "EnglishTitle": "Czech (Czech Republic)",
            "NativeTitle": "Čeština (Česká republika)",
            "IsoRegionName2": "cz",
            "IsoRegionName3": "ces",
            "IsoCurrencySymbol": "CZK",
            "NativeCurrencySymbol": "Kč",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/cz.svg"
        },
        {
            "Alias": "en-CA",
            "Culture": "en-CA",
            "EnglishTitle": "English (Canada)",
            "NativeTitle": "English (Canada)",
            "IsoRegionName2": "ca",
            "IsoRegionName3": "eng",
            "IsoCurrencySymbol": "CAD",
            "NativeCurrencySymbol": "$",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/ca.svg"
        },
        {
            "Alias": "pt-PT",
            "Culture": "pt-PT",
            "EnglishTitle": "Portuguese (Portugal)",
            "NativeTitle": "Português (Portugal)",
            "IsoRegionName2": "pt",
            "IsoRegionName3": "por",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/pt.svg"
        },
        {
            "Alias": "bg-BG",
            "Culture": "bg-BG",
            "EnglishTitle": "Bulgarian (Bulgaria)",
            "NativeTitle": "Български (България)",
            "IsoRegionName2": "bg",
            "IsoRegionName3": "bul",
            "IsoCurrencySymbol": "BGN",
            "NativeCurrencySymbol": "лв.",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/bg.svg"
        }
    ]
}

export default cultures; 